var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "introduce-container"
  }, [_c('div', {
    staticClass: "desc_wrap"
  }, [_c('span', {
    staticClass: "media_font_size_50"
  }, [_vm._v(_vm._s(_vm.$t("information.introduce1")))]), _vm._v(" "), _c('span', {
    staticClass: "media_font_size_50"
  }, [_vm._v(_vm._s(_vm.$t("information.introduce2")))]), _vm._v(" "), _c('span', {
    staticClass: "media_font_size_50"
  }, [_vm._v(_vm._s(_vm.$t("information.introduce3")))]), _vm._v(" "), _c('span', {
    staticClass: "media_font_size_50"
  }, [_vm._v(_vm._s(_vm.$t("information.introduce4")))])]), _vm._v(" "), _c('div', {
    staticClass: "img_wrap"
  }, _vm._l((_vm.imgList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "wrap_top"
    }, [_c('div', {
      staticClass: "lf_wrap"
    }, [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "flex-container"
    }, [_c('span', [_vm._v(_vm._s(item.title))])])]), _vm._v(" "), _c('div', {
      staticClass: "rt_wrap"
    }, [_c('span', [_vm._v(_vm._s(item.desc))])])]), _vm._v(" "), _c('img', {
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    })])
  }), 0)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d0f4bee","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/schedule/components/introduce.vue
// module id = null
// module chunks = 